import { QueryClient } from '@tanstack/react-query';

/**
 * Single shared QueryClient. Defaults tuned for a low-volume mobile app:
 * - 30s staleTime so HMR-y feel isn't undone by aggressive refetches
 * - retries off — Supabase errors are usually deterministic; we surface them
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
